import React, {useState, useEffect} from "react";
import SVG from 'react-inlinesvg';

export default React.memo(({srcP}) => {
    const [src, setSrc] = useState(false);

    useEffect(() => {
        srcP.then(src => {
            setSrc(src.default);
        });
    }, [])

    if(!src) {
        return <span/>
    } else {
        return <SVG src={src}/>
    }
})